"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.webSocket = void 0;
const request_js_1 = require("../../errors/request.js");
const transport_js_1 = require("../../errors/transport.js");
const rpc_js_1 = require("../../utils/rpc.js");
const createTransport_js_1 = require("./createTransport.js");
function webSocket(url) {
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    key = 'webSocket',
    name = 'WebSocket JSON-RPC',
    retryDelay
  } = config;
  return _ref => {
    var _config$retryCount, _ref2, _chain$rpcUrls$defaul;
    let {
      chain,
      retryCount: retryCount_,
      timeout: timeout_
    } = _ref;
    const retryCount = (_config$retryCount = config.retryCount) !== null && _config$retryCount !== void 0 ? _config$retryCount : retryCount_;
    const timeout = (_ref2 = timeout_ !== null && timeout_ !== void 0 ? timeout_ : config.timeout) !== null && _ref2 !== void 0 ? _ref2 : 10000;
    const url_ = url || (chain === null || chain === void 0 || (_chain$rpcUrls$defaul = chain.rpcUrls.default.webSocket) === null || _chain$rpcUrls$defaul === void 0 ? void 0 : _chain$rpcUrls$defaul[0]);
    if (!url_) throw new transport_js_1.UrlRequiredError();
    return (0, createTransport_js_1.createTransport)({
      key,
      name,
      async request(_ref3) {
        let {
          method,
          params
        } = _ref3;
        const body = {
          method,
          params
        };
        const socket = await (0, rpc_js_1.getSocket)(url_);
        const {
          error,
          result
        } = await rpc_js_1.rpc.webSocketAsync(socket, {
          body,
          timeout
        });
        if (error) throw new request_js_1.RpcRequestError({
          body,
          error,
          url: url_
        });
        return result;
      },
      retryCount,
      retryDelay,
      timeout,
      type: 'webSocket'
    }, {
      getSocket() {
        return (0, rpc_js_1.getSocket)(url_);
      },
      async subscribe(_ref4) {
        let {
          params,
          onData,
          onError
        } = _ref4;
        const socket = await (0, rpc_js_1.getSocket)(url_);
        const {
          result: subscriptionId
        } = await new Promise((resolve, reject) => rpc_js_1.rpc.webSocket(socket, {
          body: {
            method: 'eth_subscribe',
            params
          },
          onResponse(response) {
            if (response.error) {
              reject(response.error);
              onError === null || onError === void 0 || onError(response.error);
              return;
            }
            if (typeof response.id === 'number') {
              resolve(response);
              return;
            }
            if (response.method !== 'eth_subscription') return;
            onData(response.params);
          }
        }));
        return {
          subscriptionId,
          async unsubscribe() {
            return new Promise(resolve => rpc_js_1.rpc.webSocket(socket, {
              body: {
                method: 'eth_unsubscribe',
                params: [subscriptionId]
              },
              onResponse: resolve
            }));
          }
        };
      }
    });
  };
}
exports.webSocket = webSocket;
//# sourceMappingURL=webSocket.js.map